export default "__VITE_ASSET__DsEaDpmS__"